import { useCallback, memo } from 'react';
import Box from '../Box/Box';
import Text from '../Text/Text';
import { CheckboxProps } from './Checkbox.types';
import PressableIcon from '../PressableIcon/PressableIcon';

function Checkbox({
  checked,
  onChange,
  disabled,
  error,
  labelKey,
  labelNS,
  children,
  testID,
  ...rest
}: CheckboxProps) {
  const onPress = useCallback(() => {
    if (!disabled) {
      onChange(!checked);
    }
  }, [disabled, checked, onChange]);

  return (
    <Box
      gap="space-050"
      flexDirection="row"
      alignItems="center"
      opacity={disabled ? 0.5 : 1}
      {...rest}
    >
      <PressableIcon
        name={checked ? 'checkboxChecked' : 'checkbox'}
        color={error ? 'darkSurfaceError' : 'darkSurfaceSecondary'}
        onPress={onPress}
        testID={testID}
      />
      {labelKey ? (
        <Text
          variant="body-s"
          locKey={labelKey}
          locNS={labelNS}
          color={error ? 'darkSurfaceError' : 'darkSurfaceSecondary'}
        />
      ) : (
        children
      )}
    </Box>
  );
}

export default memo(Checkbox);
